var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',_vm._b({style:(_vm.style),attrs:{"color":_vm.borderColor}},'v-card',_vm.$attrs,false),[_c('v-sheet',{attrs:{"color":_vm.color}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }